import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

Vue.config.productionTip = false

const fixIdScrolling = {
	watch: {
		$route (to, from) {
			const currentRoute = this.$router.currentRoute
			const idToScrollTo = currentRoute.hash
			this.$nextTick(() => {
				if (idToScrollTo && document.querySelector(idToScrollTo)) {
					document.querySelector(idToScrollTo).scrollIntoView()
				}
			})
		}
	}
}

Vue.directive(
	'onscroll', {
		inserted: function (el, binding) {
			switch (binding.arg) {
			case 'inview':
				for	(var key of Object.keys(binding.modifiers)) {
					el.classList.add(key)
				}
				let isInview = function (evt) {
					var rect = el.getBoundingClientRect()
					if (rect.top < window.innerHeight && rect.bottom >= 0) {
						el.classList.add('inview')
					} else {
						el.classList.remove('inview')
					}
				}
				window.addEventListener('scroll', isInview)
				break
			case 'navbar':
				let isScrolledDown = function (evt) {
					if (window.pageYOffset >= window.innerHeight - 50) {
						el.classList.add('solid')
					} else {
						el.classList.remove('solid')
					}
				}
				window.addEventListener('scroll', isScrolledDown)
				break
			default:
				break
			}
		}
	}
)

new Vue({
	mixins: [fixIdScrolling],
	router,
	store,
	render: h => h(App)
}).$mount('#app')
